import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { CertDdosLineChart } from "../../../../components/cert/cert-ddos-line-chart/cert-ddos-line-chart";
import { CertMitigation } from "../../../../components/cert/cert-mitigation/cert-mitigation";
import { CertSecurity } from "../../../../components/cert/cert-security/cert-security";

@Component({
  selector: "ddos-tab",
  templateUrl: "ddos-tab.html",
  styleUrl: "../../cert.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CertMitigation, CertSecurity, TranslatePipe, CertDdosLineChart],
})
export class DdosTab {}
